import React from "react";
import { ParamsData } from "../model/ParamsData";
import { Modal, Box, Typography, TextField, Button } from "@material-ui/core";
import Axios from "axios";

interface WebhookParamsProps {
  handleClose: () => void;
  name: string;
}

interface WebhookDetailsState extends ParamsData {
  bodyError: boolean;
}

class WebhookParams extends React.Component<
  WebhookParamsProps,
  WebhookDetailsState
> {
  constructor(props: WebhookParamsProps) {
    super(props);
    this.state = {
      status: 200,
      body: "",
      bodyError: false,
    };
  }

  handleChangeStatus = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value;
    if (!/^[0-9]{0,3}$/.test(value)) {
      return;
    }
    this.setState({
      status: parseInt(value),
    });
  };

  handleChangeBody = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({
      body: event.target.value,
    });
  };

  componentDidMount() {
    this.getData();
  }

  getData() {
    try {
      Axios.get<ParamsData>(`/params/${this.props.name}`).then(({ data }) => {
        const { body, status } = data;
        this.setState({
          status: status || 200,
          body: body,
        });
      });
    } catch (error) {
      console.error(error);
    }
  }

  checkBody(body: string) {
    try {
      JSON.parse(body);
      return false;
    } catch (error) {
      return true;
    }
  }

  handleBodyError(errorState: boolean) {
    console.log("HANDLE", errorState);
    
    this.setState({ bodyError: errorState });
  }

  async postData() {
    const { body, status } = this.state;

    const bodyError = this.checkBody(body);
    this.handleBodyError(bodyError);
    if (bodyError) {
      return;
    }

    try {
      await Axios.post(`/params/${this.props.name}`, {
        status,
        body,
      });
      this.props.handleClose();
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    return (
      <Modal open={true} onClose={this.props.handleClose}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "40rem",
            padding: "2rem",
            backgroundColor: "gray",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Response
          </Typography>
          <TextField
            id="status-input"
            label="Status"
            value={this.state.status || ""}
            onChange={this.handleChangeStatus}
          />
          <TextField
            id="body-input"
            error={this.state.bodyError}
            label="Body"
            multiline
            rows={6}
            value={this.state.body || ""}
            onChange={this.handleChangeBody}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              this.postData();
            }}
          >
            Save
          </Button>
        </Box>
      </Modal>
    );
  }
}

export default WebhookParams;
